import styled from 'styled-components'
import { Alert } from 'antd'
import { fontFamily } from 'assets/themes/theme-default'

const AntAlertStyled = styled(Alert)`
  &&& {
    .ant-alert-message {
      font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.bold.name},`}
        ${fontFamily.bold};
    }
  }
`
export default AntAlertStyled
